module.exports = __webpack_public_path__ + "static/project-20a-27e47167bd7751659b766e58bfb3b32b.png";